export const cashbackGrowthDismissedKey = (publicApiKey: string, orderId: string): string =>
  `${publicApiKey}_cashbackGrowth_dismissed_${orderId}`;

export const cashbackGrowthOrderSnapshotKey = (publicApiKey: string): string =>
  `${publicApiKey}_cashbackGrowth_orderSnapshot`;
